import React, { useEffect } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import VideoPost from "../components/VideoPost";
import { setPlayingAction } from "../store/actions/pageActions";
import { setUserInfo } from "../lib/session";
import LogoutFooter from "../components/LogoutFooter";

const VideoPage = props => {
  useEffect(() => {
    setUserInfo("loaded", true);
    window.scrollTo(0, 0);
  }, []);

  const {
    match: { params: { id } = {} } = {},
    history,
    dispatch,
    noNav,
    currentlyPlaying,
    track
  } = props;

  const playVideo = id => {
    if (id !== "") {
      dispatch(setPlayingAction(id));
      if (id) {
        track("view-video", `/videos/${id}`, ({ data }) => {
          const { trackActivity: { user: userData } = {} } = data || {};
          setUserInfo("data", userData);
        });
      }
    }
  };

  return (
    <div>
      <VideoPost
        videoId={id}
        goBack={() => {
          dispatch(setPlayingAction(false));
          history.goBack();
        }}
        track={track}
        playVideo={playVideo}
        currentlyPlaying={currentlyPlaying}
      />
      {noNav && <LogoutFooter history={history} track={track} />}
    </div>
  );
};

const mapStateToProps = state => ({
  currentlyPlaying: state.pageReducers.currentlyPlaying
});

export default connect(mapStateToProps)(withRouter(VideoPage));
